import isMobile from 'is-mobile';
import { useState } from 'react';
import { useEffectOnce } from 'react-use';

interface UseIsMobile {
  includeTablet: boolean;
}

export const useIsMobile = ({ includeTablet }: UseIsMobile) => {
  const [mobile, setMobile] = useState(true);

  useEffectOnce(() => {
    if (!isMobile({ tablet: includeTablet, featureDetect: true })) {
      setMobile(false);
    }
  });

  return mobile;
};
